import React, { Suspense } from "react";
import { SxProps, Theme } from "@mui/material";
import { usePermissions } from "../../hooks/usePermissions";

// Loaded on demand: keeps the order/customer/product drawers light, and
// avoids an import cycle (a task's drawer can itself open an order).
const LinkedTasksPanel = React.lazy(() => import("./LinkedTasksPanel"));

export interface LinkedTasksProps {
    kind: "order" | "customer" | "product";
    id: string;
    /** Order number, customer or product name — starts a new task's title. */
    label: string;
    /** Match the host's section headings: bold title, small caps, or overline with an icon. */
    heading?: "bold" | "caps" | "overline";
    sx?: SxProps<Theme>;
}

/** The record's tasks, with "Add task" — inside order, customer and product views. */
export const LinkedTasks: React.FC<LinkedTasksProps> = (props) => {
    const { isInvestor } = usePermissions();
    if (isInvestor) return null; // tasks are outside Investor access
    return (
        <Suspense fallback={null}>
            <LinkedTasksPanel {...props} />
        </Suspense>
    );
};
